import React from 'react'

import BackDrop from './../../../resources/HomePageResources/tokyo.svg'
import PlatformLeft from  './../../../resources/HomePageResources/platform-up-left.svg'
import PlatformRight from  './../../../resources/HomePageResources/platform-up-right.svg'
import '../../../styles/HomePageStyles/PlatformStyles/tokyo.css'
import TokyoTrader from './../../../resources/HomePageResources/tokyo-trader.svg'
import TokyoBank from './../../../resources/HomePageResources/tokyo-bank.svg'
import TokyoBitcoin from './../../../resources/HomePageResources/tokyo-bitcoin.svg'
import TokyoGreenUp from './../../../resources/HomePageResources/tokyo-green-up.svg'
import TokyoRedDown from './../../../resources/HomePageResources/tokyo-green-down.svg'
import TokyoAirplane from './../../../resources/HomePageResources/tokyo-airplane.svg'

import TokyoPipe from './../../../resources/HomePageResources/pipes/tokyo-pipe.svg'

export default class TokyoPlatform extends React.Component{
    render(){
        return(
            <div className="plat__container" style={{width: '340px'}}>
                <div className="plat__backdrop">
                    <img className="plat__backdrop-img" src={BackDrop} />

                    <div className="plat__content-box tokyo-content-box">

                        <div className="tokyo__flight-path">
                            <img className="tokyo__plane" src={TokyoAirplane}/>
                        </div>

                        <div className="tokyo__baseline">

                            <div className="tokyo__trader">
                                <img className="tokyo__trader-img" src={TokyoTrader}/>

                                <div className="tokyo__btc">
                                    <img src={TokyoBitcoin}/>
                                </div>

                                <div className="tokyo__up">
                                    <img src={TokyoGreenUp}/>
                                </div>

                                <div className="tokyo__down">
                                    <img src={TokyoRedDown}/>
                                </div>

                            </div>

                            <div className="tokyo__bank">
                                <img className="tokyo__bank-img" src={TokyoBank}/>
                            </div>

                        </div>

                    </div>

                </div>

                <div className="plat__platform">
                    <img className="plat__platform-left" src={PlatformLeft} />
                    <div className="plat__platform-middle" />
                    <img className="plat__platform-right" src={PlatformRight} />
                </div>
                <div className="tokyo__pipe">
                    <img src={TokyoPipe} />
                    <div className="tokyo-pipe-c-1" />
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/Platforms/TokyoPlatform.js